var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('primary-btn',_vm._b({attrs:{"to":_vm.to,"rounded":_vm.rounded,"color":_vm.color,"outlined":true,"disabled":_vm.disabled},on:{"click":_vm.click}},'primary-btn',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }